import { ClinicId } from './types';

export interface ClinicConfig {
  id: ClinicId;
  displayName: string;
  hex: string;
  pillBg: string;
  pillBorder: string;
}

// Virtual clinic id for the Clalit psy-follow-up patients blocked on HMO approval.
// Treated as a separate "clinic" pill so a single click cascades through the
// pills/histogram/breakdown/list — same machinery as a real clinic filter.
export const WAITING_APPROVAL_CLINIC_ID: ClinicId = 'WaitingApproval';

// 6 clinics — no "Urgent Consultant" in patient_status data (verified 2026-05-21).
// + 1 virtual "ממתין לאישור (כללית)" pill that only appears in followup_psy/right.
export const CLINIC_PALETTE: ClinicConfig[] = [
  { id: 'Maccabi',           displayName: 'מכבי',              hex: '#2563EB', pillBg: 'rgba(59,130,246,0.10)',  pillBorder: 'rgba(59,130,246,0.35)' },
  { id: 'Maccabi Youth',     displayName: 'מכבי נוער',         hex: '#0284C7', pillBg: 'rgba(14,165,233,0.10)',  pillBorder: 'rgba(14,165,233,0.35)' },
  { id: 'Clalit',            displayName: 'כללית',             hex: '#10B981', pillBg: 'rgba(34,197,94,0.10)',   pillBorder: 'rgba(34,197,94,0.35)' },
  // Sits next to Clalit — operationally a sub-bucket of it (Clalit patients
  // blocked on HMO approval before scheduling next psychiatrist follow-up).
  { id: WAITING_APPROVAL_CLINIC_ID, displayName: 'ממתין לאישור (כללית)', hex: '#F59E0B', pillBg: 'rgba(250,204,21,0.10)', pillBorder: 'rgba(250,204,21,0.45)' },
  { id: 'ITC',               displayName: 'חוסן',              hex: '#F59E0B', pillBg: 'rgba(245,158,11,0.10)',  pillBorder: 'rgba(245,158,11,0.35)' },
  { id: 'Private',           displayName: 'פרטי',              hex: '#8B5CF6', pillBg: 'rgba(168,85,247,0.10)',  pillBorder: 'rgba(168,85,247,0.35)' },
  { id: 'Donation',          displayName: 'תרומה',             hex: '#64748B', pillBg: 'rgba(100,116,139,0.10)', pillBorder: 'rgba(100,116,139,0.35)' },
];

const FALLBACK: ClinicConfig = {
  id: '__fallback__',
  displayName: '__fallback__',
  hex: '#94A3B8',
  pillBg: 'rgba(148,163,184,0.10)',
  pillBorder: 'rgba(148,163,184,0.35)',
};

const INDEX: Record<string, ClinicConfig> = Object.fromEntries(
  CLINIC_PALETTE.map((c) => [c.id, c]),
);

export function getClinicConfig(id: ClinicId): ClinicConfig {
  return INDEX[id] ?? { ...FALLBACK, id, displayName: id };
}
